'use client';

import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import dynamic from 'next/dynamic';
import type { PropsWithChildren } from 'react';

import { IS_SSR } from '../constants';
import { getQueryClient } from './queryClient';

const ReactQueryDevtools =
    process.env.NODE_ENV === 'development'
        ? dynamic(() => import('@tanstack/react-query-devtools').then(mod => mod.ReactQueryDevtools), { ssr: false })
        : () => null;

const persister = createSyncStoragePersister({
    storage: IS_SSR ? undefined : window.localStorage,
});

export type QueryProviderProps = PropsWithChildren;

export function QueryProvider({ children }: Readonly<QueryProviderProps>) {
    return (
        <PersistQueryClientProvider
            client={getQueryClient()}
            persistOptions={{
                persister,
                maxAge: 24 * 60 * 60 * 1000,
                // Can be set to a release version (e.g. CACHE_BUSTER_RELEASE=3.1.1) to bust stale persisted cache
                buster: '',
            }}
        >
            {children}
            <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
        </PersistQueryClientProvider>
    );
}
